export default {
  title: 'Pago',
  description: 'Todas las transacciones son seguras y están cifradas',
  show_more_payment_methods: 'Mostrar más métodos de pago',
  express_checkout_divider: 'o',
};
